module.exports = __webpack_public_path__ + "img/IT0000635659728.0f707df0.png";